import React, { useState, useEffect, useContext } from 'react'
import { useParams } from 'react-router-dom'
import { getSigners, getDocuSignEmbed, getContractById } from '../../services/apiHelper'
import { getContractSignerId } from '../../services/utils'
import DetailView from '../../dpe-usco/components/Details/DetailView'
import TableStatus from '../../components/subComponents/TableStatus/TableStatus'
import { GlobalContext, AuthContext } from '../../services/context'
import Button from 'syngenta-react-components/dist/components/Button'
import AccessDeniedView from '../Interstitial/AccessDeniedView'

const SignContractView = () => {
  const { dispatch } = useContext(GlobalContext)
  const { auth, hasAccess } = useContext(AuthContext)
  const { contract_id, company_id } = useParams()
  const [_contract_id] = useState(contract_id)
  const [_contract_signer_id, set_contract_signer_id] = useState()
  const [data, setData] = useState()
  const [status, setStatus] = useState('LOADING')
  const [hasPermission, setHasPermission] = useState('LOADING')
  const [prompt, setPrompt] = useState('')

  useEffect(()=> {
    const getCompanyIds = async () => {
      const response = await getContractById(_contract_id)
      if(response){
        const { grower_details, reseller_details, grain_receiver_details } = response.contract_details
        const compArray = [
          grower_details.grower_id, reseller_details.reseller_id, grain_receiver_details.grain_receiver_id
        ]
        const access = hasAccess(compArray, [
          'sign-contract', 'view-contract', 'approve-contract'
        ])
        if(!access){
          setHasPermission('FAILED')
        } else if (access === 'SUCCESS'){
          setHasPermission('SUCCESS')
        }
      }
    }
    if(_contract_id && hasAccess() !== 'LOADING'){
      getCompanyIds()
    }
  }, [
    _contract_id, company_id, hasAccess
  ])

  useEffect(()=> {
    const init = async () => {
      const response = await getDocuSignEmbed(_contract_id, _contract_signer_id, '/contracts/return')
      if(response){
        setData(response)
        setStatus()
      } else {
        setPrompt('Looks like this contract isn\'t formated properly. Please contact your admin.')
        setStatus('EMPTY')
      }
    }
    const parentCallback = e => {
      if (e.data === 'signing_complete') {
        dispatch({ type: 'GO_TO_CONTRACT_COMPLETE' })
      }else if (e.data === 'signing_failed') {
        dispatch({ type: 'GO_TO_DASHBOARD' })
      }
    }
    const setUpListener = () => {
      window.addEventListener('message', parentCallback, false)
    }
    if(_contract_id && _contract_signer_id){
      init()
    }
    setUpListener()

    return () => {
      window.removeEventListener('message', parentCallback, false)
    }
  }, [
    _contract_id, _contract_signer_id, dispatch
  ])

  useEffect(()=> {
    const noSigner = () => {
      setPrompt('Looks like you\'re not a signer for this contract. Please contact your admin.')
      setStatus('EMPTY')
    }
    if(_contract_id && !_contract_signer_id && auth.userInfo.phone){
      getSigners(_contract_id)
        .then(res => {
          if(res?.length){
            const contractSignerId = getContractSignerId(res, auth.userInfo.phone)
            if(contractSignerId){
              set_contract_signer_id(contractSignerId)
            } else {
              noSigner()
            }
          } else {
            noSigner()
          }
        })
    }
  }, [
    _contract_id, _contract_signer_id, auth.userInfo.phone
  ])

  if(hasPermission === 'SUCCESS'){
    return (
      <DetailView>
        <div>
          {status !== 'SUCCESS' &&
      <>
        <TableStatus status={status} prompt={prompt} />
        {status==='EMPTY' &&
      <Button styleType='success' onClick={()=> dispatch({ type: 'GO_TO_DASHBOARD' })}>Back to dashboard</Button>
        }
      </>
          }
          {data && 
      <iframe
        title='docusign-title'
        src={data}
        style={{ width: '100%', height: '75vh' }}
      />
          }
        </div>
        <>
        </>
      </DetailView>
    )
  } else if (hasPermission === 'FAILED'){
    return (
      <>
        <AccessDeniedView/>
      </>
    )
  } else {
    return (
      <>
        <TableStatus status='LOADING'/>
      </>
    )
  }
}

export default SignContractView